/*
 * @Description: 审批流相关接口
 */
import {
  ApproverUserListParamModel,
  ProcessDetailModel,
  ProcessPageModel,
  ProcessPageParamModel, ApproverUserModel, ProcessUpdateParamModel
} from '@/model/process/processModel'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { ContentType, Method } from 'axios-mapper'

const baseUrl = '/base/process'
const baseUserUrl = '/base/user'

export const getProcessPageList = (params: ProcessPageParamModel) => {
  return https().request<RootObject<ProcessPageModel>>(baseUrl + '/list', Method.POST, params, ContentType.json)
}

export const getProcessDetailById = (id: string) => {
  return https().request<RootObject<ProcessDetailModel>>(baseUrl + '/get/' + id, Method.GET, undefined, ContentType.json)
}

export const getUserList = (params: ApproverUserListParamModel) => {
  return https().request<RootObject<Array<ApproverUserModel>>>(baseUserUrl + '/list/all', Method.POST, params, ContentType.json)
}

export const saveProcess = (param: ProcessUpdateParamModel) => {
  return https().request<RootObject<number>>(baseUrl + '/update', Method.POST, param, ContentType.json)
}
